import {
  CREATE_STUDENT_INSTITUTION_URL,
  DELETE_STUDENT_INSTITUTION_URL,
  GET_ALL_STUDENT_INSTITUTION_URL,
  UPDATE_STUDENT_INSTITUTION_URL,
  RESET_STUDENT_INSTITUTION_PASSWORD_URL,
} from "../../apiurls/apiurls";

export const getAllStudentInstitution = async (token, params) => {
  const query = new URLSearchParams({});
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.search) query.set("search", String(params.search));
  if (params.grade) query.set("grade", String(params.grade));
  if (typeof params.disabled === "boolean")
    query.set("disabled", String(params.disabled));
  const url = `${GET_ALL_STUDENT_INSTITUTION_URL}?${query.toString()}`;

  try {
    const response = await fetch(`${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const createStudentInstitution = async (token, payload) => {
  const url = `${CREATE_STUDENT_INSTITUTION_URL}`;
  try {
    const response = await fetch(`${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const updateStudentInstitution = async (token, payload, id) => {
  const url = `${UPDATE_STUDENT_INSTITUTION_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const deleteStudentInstitution = async (token, id) => {
  const url = `${DELETE_STUDENT_INSTITUTION_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching page for topic:", error);
    throw error;
  }
};

export const resetStudentInstitutionPassword = async (token, payload, id) => {
  const url = `${RESET_STUDENT_INSTITUTION_PASSWORD_URL}?id=${id}`;
  try {
    const response = await fetch(`${url}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error resetting student password:", error);
    throw error;
  }
};
